import Hotjar from '@hotjar/browser';

type HotjarConfig = {
  siteId: number;
  version: number;
};

export const initHotjar = (config: HotjarConfig) => {
  Hotjar.init(config.siteId, config.version);

  if (typeof window !== 'undefined' && window.hj && typeof window.hj === 'function') {
    console.log('[Hotjar] Hotjar script is loaded.');
    reinjectStyles();
  } else {
    console.warn('[Hotjar] Hotjar script is not loaded.');
  }
};

const reinjectStyles = () => {
  const styleTags = document.head.querySelectorAll('style');

  if (styleTags.length === 0) {
    console.warn('[Styled Reinjection] No styled-components style tags found.');
    return;
  }

  const stylesContent = Array.from(styleTags).map((style) => style.textContent);

  stylesContent.forEach((content, index) => {
    const newStyleTag = document.createElement('style');
    newStyleTag.textContent = content;
    document.head.appendChild(newStyleTag);
    styleTags[index].remove();
  });

  console.log(`[Styled Reinjection] Reapplied ${styleTags.length} styled-components <style> tags.`);
};
